import React from 'react'
import { Box, Typography } from '@material-ui/core'

const SteppedContent = ({ children, title, description, progressText, action, width }) => {
  return (
    <Box textAlign="center" width={width}>
      <Box marginTop={5}>
        <img
          alt="Foodsby Logo"
          component="img"
          src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/logo-foodsby.png`}
          title="Foodsby Logo"
          style={{ maxHeight: 48 }}
        />
      </Box>
      {progressText && (
        <Box marginTop={4}>
          <Typography color="textSecondary">{progressText}</Typography>
        </Box>
      )}
      <Box marginTop={4}>
        <Typography variant="h4">{title}</Typography>
      </Box>
      <Box marginTop={3} fontSize="18px" textAlign="left">
        <Typography>{description}</Typography>
      </Box>
      <Box marginTop={4}>{children}</Box>
      <Box marginTop={4}>{action}</Box>
    </Box>
  )
}

export default SteppedContent
